import { MessageSquare, ArrowUp, ArrowDown, ArrowLeft } from 'lucide-react';

const TooltipConfig = ({ 
  tooltipSettings = {
    message: '',
    position: 'left',
    backgroundColor: '#6B46C1',
    textColor: '#FFFFFF'
  },
  onChange 
}) => {
  
  const handleChange = (field, value) => {
    const updated = {
      ...tooltipSettings,
      [field]: value
    };
    onChange?.(updated);
  };

  const positions = [
    { value: 'top', label: 'Topo', icon: ArrowUp },
    { value: 'bottom', label: 'Baixo', icon: ArrowDown },
    { value: 'left', label: 'Esquerda', icon: ArrowLeft }
  ];

  return (
    <div className="bg-white/80 backdrop-blur-sm rounded-3xl shadow-xl p-8">
      <h3 className="text-2xl font-bold text-gray-900 flex items-center gap-3 mb-6">
        <MessageSquare className="w-8 h-8 text-indigo-600" />
        Configuração do Tooltip
      </h3>
      
      <div className="space-y-6">
        {/* Mensagem do Tooltip */}
        <div>
          <label className="block text-lg font-semibold text-gray-700 mb-2">
            Mensagem do Tooltip
          </label>
          <input
            type="text"
            value={tooltipSettings.message}
            onChange={(e) => handleChange('message', e.target.value)}
            className="w-full px-5 py-4 text-lg border-2 border-gray-200 rounded-2xl focus:ring-4 focus:ring-indigo-100 focus:border-indigo-500 transition-all"
            placeholder="Ex: Precisa de ajuda? Clique aqui!"
          />
          <p className="text-sm text-gray-500 mt-2">
            Deixe vazio para não exibir tooltip
          </p>
        </div>

        {/* Posição do Tooltip */}
        <div>
          <label className="block text-lg font-semibold text-gray-700 mb-3">
            Posição do Tooltip
          </label>
          <div className="grid grid-cols-3 gap-3">
            {positions.map(({ value, label, icon: Icon }) => (
              <button
                key={value}
                onClick={() => handleChange('position', value)}
                className={`px-4 py-3 rounded-xl border-2 transition-all flex items-center justify-center gap-2 font-medium ${
                  tooltipSettings.position === value
                    ? 'border-indigo-500 bg-indigo-50 text-indigo-700'
                    : 'border-gray-200 hover:border-gray-300 text-gray-600'
                }`}
              >
                <Icon className="w-4 h-4" />
                {label}
              </button>
            ))}
          </div>
        </div>

        {/* Cores do Tooltip */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-base font-semibold text-gray-700 mb-2">
              Cor de Fundo
            </label>
            <div className="flex items-center gap-3">
              <input
                type="color"
                value={tooltipSettings.backgroundColor}
                onChange={(e) => handleChange('backgroundColor', e.target.value)}
                className="w-16 h-16 rounded-xl border-2 border-gray-200 cursor-pointer"
              />
              <input
                type="text"
                value={tooltipSettings.backgroundColor}
                onChange={(e) => handleChange('backgroundColor', e.target.value)}
                className="flex-1 px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-indigo-100 focus:border-indigo-500"
                placeholder="#6B46C1"
              />
            </div>
          </div>

          <div>
            <label className="block text-base font-semibold text-gray-700 mb-2">
              Cor do Texto
            </label>
            <div className="flex items-center gap-3">
              <input
                type="color"
                value={tooltipSettings.textColor}
                onChange={(e) => handleChange('textColor', e.target.value)}
                className="w-16 h-16 rounded-xl border-2 border-gray-200 cursor-pointer"
              />
              <input
                type="text"
                value={tooltipSettings.textColor}
                onChange={(e) => handleChange('textColor', e.target.value)}
                className="flex-1 px-4 py-3 border-2 border-gray-200 rounded-xl focus:ring-4 focus:ring-indigo-100 focus:border-indigo-500"
                placeholder="#FFFFFF"
              />
            </div>
          </div>
        </div>

        {/* Preview do Tooltip */}
        {tooltipSettings.message && (
          <div className="mt-6">
            <label className="block text-base font-semibold text-gray-700 mb-3">
              Visualização de como o tooltip aparecerá no widget
            </label>
            <div className="bg-gray-50 rounded-2xl p-8 pt-20 flex items-center justify-center">
              <div className="relative">
                {/* Botão de exemplo */}
                <div 
                  className="w-16 h-16 rounded-full bg-indigo-600 flex items-center justify-center shadow-lg"
                >
                  <MessageSquare className="w-8 h-8 text-white" />
                </div>
                
                {/* Tooltip Preview */}
                <div
                  className="absolute px-3 py-2 rounded-lg shadow-xl whitespace-nowrap text-sm font-medium"
                  style={{
                    backgroundColor: tooltipSettings.backgroundColor,
                    color: tooltipSettings.textColor,
                    ...(tooltipSettings.position === 'top' && {
                      bottom: 'calc(100% + 8px)',
                      left: '50%',
                      transform: 'translateX(-50%)'
                    }),
                    ...(tooltipSettings.position === 'bottom' && {
                      top: 'calc(100% + 8px)',
                      left: '50%',
                      transform: 'translateX(-50%)'
                    }),
                    ...(tooltipSettings.position === 'left' && {
                      right: 'calc(100% + 8px)',
                      top: '50%',
                      transform: 'translateY(-50%)'
                    })
                  }}
                >
                  {tooltipSettings.message}
                  
                  {/* Seta do tooltip */}
                  <div
                    className="absolute w-0 h-0"
                    style={{
                      ...(tooltipSettings.position === 'top' && {
                        top: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        borderLeft: '6px solid transparent',
                        borderRight: '6px solid transparent',
                        borderTop: `6px solid ${tooltipSettings.backgroundColor}`
                      }),
                      ...(tooltipSettings.position === 'bottom' && {
                        bottom: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        borderLeft: '6px solid transparent',
                        borderRight: '6px solid transparent',
                        borderBottom: `6px solid ${tooltipSettings.backgroundColor}`
                      }),
                      ...(tooltipSettings.position === 'left' && {
                        left: '100%',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        borderTop: '6px solid transparent',
                        borderBottom: '6px solid transparent',
                        borderLeft: `6px solid ${tooltipSettings.backgroundColor}`
                      })
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TooltipConfig;